module.exports = __webpack_public_path__ + "static/img/animal.277db517.png";